
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { StatusIconViewModel } from '@/view-models';
  import { DashboardCountStatus } from '@/models';

  @Component
  export default class McCountStatusButton extends Vue {
    @Prop() readonly label!: string;
    @Prop([Array, String]) readonly labelIcon!: any[] | string;
    @Prop() readonly count!: number;
    @Prop() readonly status!: DashboardCountStatus;
    @Prop() readonly showIcon!: boolean;
    @Prop([Function]) readonly click!: any;

    get hasIcon() {
      return this.statusIcon && this.statusIcon.icon !== '';
    }

    get buttonClass() {
      return this.showCount ? 'processed-btn' : '';
    }

    get countFormat() {
      return this.showCount ? `(${this.count})` : '';
    }

    get showCount() {
      const showCountForStatuses = ['affirmed', 'affirmDraft', 'draft'];
      const showCount =
        this.count !== null
        && (this.count > 0
          || (this.count == 0 && this.status && showCountForStatuses.some(n => n === this.statusIcon.name)));
      return showCount;
    }

    get statusIcon() {
      const noContent = new StatusIconViewModel(
        'noContent',
        s => !s.exists,
        'status-icon-holder',
        '');

      const recNoServe = new StatusIconViewModel(
        'recNoServe',
        s => s.received && !s.served,
        'status-icon-holder',
        '');

      const draft = new StatusIconViewModel(
        'draft',
        s => s.received && s.served && s.drafts && !s.affirmed,
        'status-icon-holder',
        'ellipsis-h');

      const affirmed = new StatusIconViewModel(
        'affirmed',
        s => s.affirmed && !s.drafts,
        'status-icon-holder completed',
        'check');

      const affirmDraft = new StatusIconViewModel(
        'affirmDraft',
        s => s.affirmed && s.drafts,
        'status-icon-holder',
        'check-circle');

      const iconSet = [noContent, affirmDraft, affirmed, draft, recNoServe];

      const statusIcon = iconSet.find(i => i.match(this.status));
      const result = statusIcon ? statusIcon : noContent;
      return result;
    }
  }
